import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Option } from './styles';
import { Switch } from '../../Switch/Switch';
import { Text } from '../../Text';
export var CookieOption = function (_a) {
  var content = _a.content,
    isAllowed = _a.isAllowed,
    name = _a.name,
    onOptionChange = _a.onOptionChange;
  return _jsxs(_Fragment, {
    children: [_jsx(Text, {
      el: "p",
      styleName: "bodyRegular",
      children: _jsx("strong", {
        children: content.label
      })
    }), _jsxs(Option, {
      children: [_jsx(Text, {
        el: "span",
        styleName: "bodySmall",
        variant: "secondary",
        children: content.description
      }), _jsx(Switch, {
        checked: isAllowed,
        onChange: function (value) {
          return onOptionChange(name, value);
        }
      })]
    })]
  });
};